export default () => {
  const sayHelloForm = document.querySelector('.c-say-hello');

  if (!sayHelloForm) {
    return;
  }

  const setMessage = message => {
    sayHelloForm.querySelector(
      '.c-say-hello__error-message',
    ).textContent = message;
  };

  let sending = false;
  const submitButton = sayHelloForm.querySelector('.c-say-hello__submit');
  let submitText = '';

  /* const recaptchaScript = sayHelloForm.querySelector(
    '#say-hello-recaptcha-script',
  );

  let recaptchaReady = false;
  let recaptchaSolved = false;
  let recaptchaWidgetId = -1;

  if (recaptchaScript) {
    window.sayHelloRecaptchaOnload = () => {
      recaptchaReady = true;
      recaptchaWidgetId = window.grecaptcha.render(
        sayHelloForm.querySelector('.c-say-hello-recaptcha'),
        {
          callback: () => {
            recaptchaSolved = true;
          },
          'expired-callback': () => {
            recaptchaSolved = false;
          },
        },
      );
    };

    const fields = sayHelloForm.querySelectorAll('input, textarea');
    [...fields].forEach(el =>
      el.addEventListener(
        'focus',
        () => {
          if (recaptchaScript.dataset.src) {
            recaptchaScript.src = recaptchaScript.dataset.src;
            recaptchaScript.removeAttribute('data-src');
          }
        },
        {
          once: true,
        },
      ),
    );
  } */

  const onSubmit = event => {
    event.preventDefault();

    if (sending) {
      return;
    }

    /* if (recaptchaScript && (!recaptchaReady || !recaptchaSolved)) {
      setMessage('Please fill all fields and tick "I am not a robot" field');
      return;
    } */

    sayHelloForm.querySelector(
      '[name="click-param"]',
    ).value = new Date().getTime();

    const formData = new FormData(sayHelloForm);
    formData.append('action', 'say_hello');

    setMessage('');
    submitText = submitButton.textContent;
    submitButton.textContent = 'Sending...';

    fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          sayHelloForm.reset();
          sayHelloForm.classList.add('is-sent');
        } else {
          setMessage(data.data.message);

          /* if (recaptchaScript) {
            console.log('resetting: ', recaptchaWidgetId);
            window.grecaptcha.reset(recaptchaWidgetId);
          } */
        }
      })
      .catch(() => {
        setMessage('Server error, please try again');
      })
      .finally(() => {
        sending = false;
        submitButton.textContent = submitText;
      });
  };

  sayHelloForm.addEventListener('submit', onSubmit);
};



// WEBPACK FOOTER //
// ./src/scripts/modules/say-hello.js